
export default {
  resize: function (base64String) {
    let img = new Image()
    let ImageResizer = this
    let resizedImage = null

    img.src = base64String
    img.onload = function () {
      let ratios = ImageResizer.getAspectRatio(img.width, img.height)
      console.log(ratios)

      let canvas = document.createElement('canvas')
      let ctx = canvas.getContext('2d')

      canvas.width = ratios.width
      canvas.height = ratios.height

      ctx.drawImage(this, 0, 0, canvas.width, canvas.height)

      resizedImage = canvas.toDataURL()
    }

    return resizedImage
  },

  getAspectRatio: function (srcWidth, srcHeight) {
    let ratio = srcWidth / srcHeight

    return {
      width: 1000,
      height: Math.ceil(1000 / ratio)
    }
  }
}
